import React from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { EmptyState } from '../shared/empty-state/empty-state'
import { IconSearch } from '../shared/icon/icon'
import { useLoginRedirect } from '../layout/unauthorized/auth/hooks/redirect'

// The signed-in app has no single <Switch>: LayoutRoot, LayoutAdmin and
// LayoutOrg each draw their own <Route>s side by side, so a URL none of them
// knows (the click-through's /org/content) used to draw an empty body.
//
// These are the sections those layouts route under. Every page lives inside
// one, so a URL outside all of them is not found. not-found.test.js scans the
// layouts and fails when a route is outside every section or a section has
// no route, so this list cannot drift.
export const AUTHORIZED_SECTIONS = [
  '/admin-node/root',
  '/admin/ai-tools',
  '/admin/alert-routing',
  '/admin/api-keys',
  '/admin/app',
  '/admin/audit-log',
  '/admin/audit-retention',
  '/admin/billing',
  '/admin/consent-log',
  '/admin/auth-session',
  '/admin/dashboard',
  '/admin/device-login-denial',
  '/admin/email-activity',
  '/admin/errors',
  '/admin/login',
  '/admin/notify',
  '/admin/organization',
  '/admin/packages',
  '/admin/provider',
  '/admin/request-log',
  '/admin/sendgrid-event',
  '/admin/sso',
  '/admin/signin-method',
  '/admin/signin-methods',
  '/org/analytic',
  '/org/api-keys',
  '/org/audit-log',
  '/org/dashboard',
  '/org/delete-account',
  '/org/email-activity',
  '/org/group',
  '/org/lms',
  '/org/login-provider',
  '/org/login-session',
  '/org/login-setting',
  '/org/node-content',
  '/org/node-library',
  '/org/node-template',
  '/org/notification-activity',
  '/org/notifications',
  '/org/organization',
  '/org/password-update',
  '/org/self-register',
  '/org/sso',
  '/org/tradeshow',
  '/org/user',
  '/root/analytic-configure',
  '/root/role-org',
  '/root/role-org-permission',
  '/root/role-sys',
  '/root/role-sys-permission',
  '/root/sys-admin'
]

// "/" (and "") belong to RedirectDashboard, which sends the person to their
// landing page.
export const isKnownAuthorizedPath = pathname => {
  if (!pathname || pathname === '/') return true
  return AUTHORIZED_SECTIONS.some(path => !!matchPath(pathname, { path }))
}

export const NotFoundPage = ({ pathname }) => {
  const loginRedirect = useLoginRedirect()

  return (
    <div className="d-flex justify-content-center pt-5">
      <EmptyState
        Icon={IconSearch}
        title="Page not found"
        message={`There is no page at ${pathname}. Check the address, or go back to your home page.`}
        action={{ label: 'Go to your home page', onClick: () => loginRedirect() }}
      />
    </div>
  )
}

// Drawn beside the signed-in layouts: nothing for a known URL, the not-found
// page for anything else.
export const UnknownRoute = () => {
  const { pathname } = useLocation()

  if (isKnownAuthorizedPath(pathname)) return null

  return <NotFoundPage pathname={pathname} />
}
